<template>
	<div>
		<h3>Add new video</h3>
		<form class="form border p-3">
			<div class="form-group">
				<label>number</label>
				<input class="form-control" type="number" v-model="number">
			</div>
			<div class="form-group">
				<label>title</label>
				<input class="form-control" type="text" v-model="title">
			</div>
			<div class="form-group">
				<label>url</label>
				<input class="form-control" type="text" v-model="course_url">
			</div>
			<div class="form-group">
				<label>duration</label>
				<input class="form-control" type="text" v-model="duration">
			</div>
			<div class="form-group">
				<label>locked</label>
				<select class="form-control" v-model="locked">
					<option value="false">false</option>
					<option value="true">true</option>
				</select>
			</div>
			<div class="form-group text-right">
				<button type="button" class="btn" @click="submit">submit</button>
			</div>
		</form>
	</div>
</template>
<script>
	import App from '@/App'

	export default {
		data: () => {
			return {
				url: App.data().url,

				number: 0,
				title: '',
				course_url: '',
				duration: '',
				locked: true
			}
		},
		mounted(){
			
		},
		methods: {
			submit(){
				var data = {
					course_id: null,
					section_id: null,
					number: this.number,
					title: this.title,
					url: this.course_url,
					duration: this.duration,
					locked: this.locked
				}
				
				console.log(data)
				App.methods.postData(this.url.video, data, () => {
					console.log('ok')
				})
			}
		}
	}
</script>